import View from "../Base/View";
import Text from "../Base/Text";
import util from "../../utils/util";
import './index.scss'
import { HTMLAttributes } from "react";
import Image from "../Base/Image";

const EmptyTip = (prop: {
    data: {
        icon?: string,
        tip: string,
        btn?: string,
    },
    emptyBtnClick?: () => void
} & HTMLAttributes<HTMLDivElement>) => {
    return <View className="empty-tip"
        {...prop}>
        {prop.data.icon && <Image className="empty-tip-icon" src={prop.data.icon}></Image>}
        {!util.isEmpty(prop.data.tip) && <Text className="empty-tip-text" >{prop.data.tip}</Text>}
        {!util.isEmpty(prop.data.btn) && prop.emptyBtnClick && <View className="empty-tip-btn" onClick={prop.emptyBtnClick}>{prop.data.btn}</View>}
    </View>
}

export default EmptyTip;